import { motion } from "framer-motion";
import { Home, Briefcase, TrendingUp } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const PILLAR_META = [
    {
        id: "live",
        icon: Home,
        image: "https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/5dbsffd3_Imagen%2021-4-26%20a%20las%2021.21%20%282%29.jpeg",
        colSpan: "lg:col-span-7",
    },
    {
        id: "work",
        icon: Briefcase,
        image: "https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/g22a06j4_Imagen%2021-4-26%20a%20las%2021.21%20%281%29.jpeg",
        colSpan: "lg:col-span-5",
    },
    {
        id: "earn",
        icon: TrendingUp,
        image: "https://customer-assets.emergentagent.com/job_wynwood-short-term/artifacts/qei9rsrf_Imagen%2021-4-26%20a%20las%2021.22.jpeg",
        colSpan: "lg:col-span-12",
    },
];

function Pillar({ pillar, index }) {
    const { t } = useT();
    const Icon = pillar.icon;
    return (
        <motion.article
            id={pillar.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: index * 0.1 }}
            className={`relative group overflow-hidden border border-white/5 hover:border-gold/40 transition-colors duration-700 bg-charcoal-surface ${pillar.colSpan} col-span-12`}
            data-testid={`pillar-${pillar.id}`}
        >
            <div className="absolute inset-0">
                <img
                    src={pillar.image}
                    alt={t(`vp.${pillar.id}.title`)}
                    className="w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-[1200ms]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/20" />
            </div>
            <div className="relative z-10 p-8 md:p-12 min-h-[380px] lg:min-h-[420px] flex flex-col justify-end">
                <div className="flex items-center gap-3 mb-4">
                    <Icon size={16} className="text-gold" strokeWidth={1.6} />
                    <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                        {t(`vp.${pillar.id}.overline`)}
                    </span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl lg:text-4xl font-semibold leading-tight tracking-tight text-white max-w-xl">
                    {t(`vp.${pillar.id}.title`)}
                </h3>
                <p className="mt-4 text-white/70 text-sm md:text-base max-w-lg leading-relaxed">
                    {t(`vp.${pillar.id}.body`)}
                </p>
            </div>
        </motion.article>
    );
}

export default function ValueProp() {
    const { t } = useT();
    return (
        <section
            className="relative py-24 md:py-32 bg-charcoal"
            data-testid="value-prop-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-5">
                            <span className="inline-block w-8 h-[1px] bg-gold" />
                            <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                                {t("vp.overline")}
                            </span>
                        </div>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight font-semibold max-w-2xl leading-[1.05]">
                            {t("vp.heading")}
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md text-sm md:text-base leading-relaxed">
                        {t("vp.subhead")}
                    </p>
                </div>

                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    {PILLAR_META.map((p, i) => (
                        <Pillar pillar={p} index={i} key={p.id} />
                    ))}
                </div>
            </div>
        </section>
    );
}
